import { AlgoliaRouting } from "@components/AlgoliaCustomComponents";
import Autocomplete from "@components/AlgoliaCustomComponents/Autocomplete/Autocomplete";
import { QueryStringStorageProvider } from "@contexts/QueryStringStorageContext";
import { useLocale } from "@jmc/core/src/hooks/useLocale/index";
import algoliasearch, { SearchClient } from "algoliasearch/lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { Configure, InstantSearch } from "react-instantsearch";

import { CONTENT_TYPES, INDEX_CONTENT } from "../../search/algolia-indexes";
import CustomRecipeHits from "./CustomRecipeHits/CustomRecipeHits";
import { HITS_PER_PAGE, RecipeGridProps } from "./RecipeGrid";
import { RecipeGridFilters } from "./RecipeGridFilters";
import style from "./style.module.scss";

export const RecipeGridBranded = (props: RecipeGridProps): JSX.Element => {
    const { enabledFilters, placement = null, specialty } = props;
    const { t } = useTranslation();
    const locale = useLocale();
    const placementHashString = placement?.replaceAll(/ |:|\|/g, "");

    let specialtyHashString = "";

    if (specialty) {
        specialty.forEach((spec) => {
            specialtyHashString = `${specialtyHashString}${spec.id}`;
        });
    }

    const hashKey = `${placementHashString}-${specialtyHashString}`;
    const algoliaClient = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY);

    const specialtyFiltersArray =
        specialty?.length &&
        specialty.map((spec) => {
            return `specialty:"${spec.title}"`;
        });

    const specialtyFiltersString = specialtyFiltersArray?.length && specialtyFiltersArray.join(" OR ");
    const filtersString = specialtyFiltersString
        ? `locale:${locale} AND (${specialtyFiltersString}) AND content_type:'${CONTENT_TYPES.RECIPE}'`
        : `locale:${locale} AND content_type:'${CONTENT_TYPES.RECIPE}'`;

    // add filters param if not exists on initial load to Algolia.
    const algoliaSearchClient = {
        ...algoliaClient,
        search(requests) {
            const params = requests?.[0]?.params;
            if (!params?.filters) {
                params.filters = filtersString;
            }
            return algoliaClient.search(requests);
        },
    } as SearchClient;

    return (
        <QueryStringStorageProvider hashKey={hashKey}>
            <InstantSearch indexName={INDEX_CONTENT} searchClient={algoliaSearchClient} routing={AlgoliaRouting}>
                <div>
                    <div className={style.searchBox}>
                        <Autocomplete
                            searchClient={algoliaClient}
                            placeholder={t("Search for recipes", { ns: "recipe" })}
                            indexName={INDEX_CONTENT}
                            contentType={CONTENT_TYPES.RECIPE}
                        />
                    </div>
                    <Configure filters={filtersString} hitsPerPage={HITS_PER_PAGE} />

                    <RecipeGridFilters availableFilters={enabledFilters} />
                    <CustomRecipeHits placement={placement} />
                </div>
            </InstantSearch>
        </QueryStringStorageProvider>
    );
};

export default RecipeGridBranded;
